import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as detailActions from "../../redux/actions/detailsActions";

import "../categories/category.css";
import styled from "styled-components";
import "../movies/movies.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import "../watch-later/later.css";
class WatchLater extends Component {
  movieDetail(movieId) {
    localStorage.setItem("id", movieId);
    this.props.actions.getChoosenMovie(parseInt(localStorage.getItem("id")));
  }

  renderEmpty() {
    return (
      <Container>
        <h3 className="text-light mt-5 text-later">There is no movie yet...</h3>
      </Container>
    );
  }
  renderMovies() {
    return (
      <Container className="cont" data-anime="left" style={{marginTop:"100px"}}>
        <h3 className="text-light text-later" style={{marginBottom:"70px"}}>
          {JSON.parse(localStorage.getItem("addedMovies")).length} Movies in total have been added.
        </h3>
        <Content className="content">
          {JSON.parse(localStorage.getItem("addedMovies")).map((movie, key) => (
            <Wrap key={movie.title}>
              <Link
                key={key}
                onClick={() => this.movieDetail(movie.id)}
                to={`/movie/${movie.id}`}
                onContextMenu={() => this.movieDetail(movie.id)}
              >
                <LazyLoadImage
                  effect="blur"
                  alt={movie.title}
                  src={`https://image.tmdb.org/t/p/original/${movie.poster_path}`}
                  key={movie.poster_path}
                />
              </Link>
            </Wrap>
          ))}
        </Content>
      </Container>
    );
  }

  render() {
    return (
      <div>
        {JSON.parse(localStorage.getItem("addedMovies"))
          ? this.renderMovies()
          : this.renderEmpty()}
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
      choosenMovie: state.detailReducer
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      actions: {
        getChoosenMovie: bindActionCreators(detailActions.getMovie, dispatch)
      },
    };
  }
  export default connect(mapStateToProps, mapDispatchToProps)(WatchLater);

const Container = styled.div`
  padding: 0 0 26px;
  justify-content: center;
  text-align: center;
  transition: 0.4s ease-in-out;
  background: #090b13;
`;

const Content = styled.div`
  display: grid;
  grid-gap: 25px;
  gap: 25px;
  margin: auto;
  margin-top: 1%;
  width: 90%;
  transition: 0.4s ease-in-out;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 500px) {
    width: 98%;
  }
`;

const Wrap = styled.div`
  padding-top: 140.25%;
  border-radius: 1.1rem;
  box-shadow: rgb(0 0 0 / 69%) 0px 26px 30px -10px,
    rgb(0 0 0 / 73%) 0px 16px 10px -10px;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s;
  border: 3px solid rgba(249, 249, 249, 0.1);
  img {
    inset: 0px;
    display: block;
    height: 100%;
    object-fit: cover;
    opacity: 1;
    position: absolute;
    transition: opacity 500ms ease-in-out 0.2s;
    width: 100%;
    z-index: 0;
    top: 0;
  }

  &:hover {
    box-shadow: rgb(0 0 0 / 80%) 0px 40px 58px -16px,
      rgb(0 0 0 / 72%) 0px 30px 22px -10px;
    transform: scale(1.04);
    border-color: rgba(249, 249, 249, 0.8);
  }
`;
